import { render, staticRenderFns } from "./ShippingOrderDetailDialog.vue?vue&type=template&id=508b6a14&scoped=true"
import script from "./ShippingOrderDetailDialog.vue?vue&type=script&lang=ts"
export * from "./ShippingOrderDetailDialog.vue?vue&type=script&lang=ts"
import style0 from "./ShippingOrderDetailDialog.vue?vue&type=style&index=0&id=508b6a14&prod&scoped=true&lang=css"
import style1 from "./ShippingOrderDetailDialog.vue?vue&type=style&index=1&id=508b6a14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508b6a14",
  null
  
)

export default component.exports